import React, {useState} from "react";
import { getCustomStyles } from "./field-themes";
import CreatableSelect from 'react-select/creatable';
import {classNames, getProp} from "../../common/util/util-helpers";

export default function FieldCreatableSelect({item, loadOptions, options, defaultOptions, onChange}) {
    if (!item?.props) {
        item.props = {}
    }

    const [value, setValue] = useState('');

    const createOption = (label) => {
        return ({
            label,
            value: label,
            manual: true,
        });
    }

    const handleInputChange = (inputValue) => {
        setValue(inputValue);
    };

    const submitOption = (e) => {
        if (!e.target.value) return;

        onChange(item.name, [...getProp(item, "value", []), createOption(e.target.value)]);

        setValue("")
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            submitOption(e)
        }
    }

    return (
        <React.Fragment>
            <CreatableSelect
                ref={item.props.innerRef}
                styles={getCustomStyles()}
                inputId={item.props.id ?? item.name}
                className={
                    classNames(item.props.className ?? "select-css-search p-0 form-control",
                        item.props.addClass
                    )
                }
                isDisabled={!!item.disabled}
                onChange={(selectedOption) => {
                    onChange(item.name, selectedOption);
                }}

                name={item.name}
                value={item.value}
                options={options}
                onCreateOption={
                    item.props.onCreateOption ?
                        (value) => item.props.onCreateOption(item.name, value) :
                        null
                }
                onBlur={(e) => submitOption(e)}
                inputValue={value}
                onInputChange={handleInputChange}
                components={item.props?.components}
                onKeyDown={onKeyDown}
                menuIsOpen={item.props?.menuIsOpen}
                loadOptions={loadOptions}
                defaultOptions={!!defaultOptions}
                isClearable={!!item.props.isClearable}
                isMulti={item.props.isMulti}
                placeholder={!!item.props.placeholder ? item.props.placeholder : 'Select...'}
                formatCreateLabel={!!item.props.formatCreateLabel ?
                    item.props.formatCreateLabel :
                    userInput => 'Create "' + userInput + '"'}
                menuPortalTarget={item.props.hasPortal ? document.body : null}
            />
        </React.Fragment>
    )
}
